import React from 'react';
import { useQRCode } from 'next-qrcode';

function QRGenerator(props) {
  const { Canvas } = useQRCode();

  return (
    <Canvas
      text={props.data}
      options={{
        level: 'M',
        margin: 0,
        scale: 1,
        width: 800,
        color: {
          dark: '#010599FF',
          light: '#FFFFFFFF',
        },
      }}
    />
  );
};

export default QRGenerator;
